import {IThemeIcons} from '../architecture/sections/theme-icons.interface';
import {InfoIcon} from './icons/info.icon';
import { BackIcon } from './icons/back.icon';
import { ForwardIcon } from './icons/forward.icon';
import { CloseIcon } from './icons/close.icon';
import { SafeZoneIcon } from './icons/safe-zone.icon';
import { HelpIcon } from './icons/help.icon';
import { TwoCharsIcon } from './icons/two-chars.icon';
import { EarthGlobeIcon } from './icons/earth-globe.icon';

export const ThemeDefaultIcons: IThemeIcons = {
    infoIcon: InfoIcon,
    backIcon: BackIcon,
    forwardIcon: ForwardIcon,
    closeIcon: CloseIcon,
    safeZoneIcon: SafeZoneIcon,
    helpIcon: HelpIcon,
    twoCharsIcon: TwoCharsIcon,
    earthGlobeIcon: EarthGlobeIcon
};
